import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useHistory } from 'react-router-dom';
import { AUTH0_APP_STATE, getAuth0RedirectUri } from '../config/auth0';

export default function Auth0ProviderWithHistory({ children }) {
  const history = useHistory();

  const onRedirectCallback = (appState) => {
    history.replace(appState?.returnTo || AUTH0_APP_STATE.returnTo);
  };

  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{ redirect_uri: getAuth0RedirectUri() }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      {children}
    </Auth0Provider>
  );
}
